import { SET_MODAL_SETTINGS } from '../actions/types';

export default function modalSettings(
	state = {
		persistIndex: true
	},
	action
) {
	if (!action.error && action.payload) {
		const newProps = action.payload;
		switch (action.type) {
			case SET_MODAL_SETTINGS: {
				return {
					...state,
					...newProps
				};
			}
			// no default
		}
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/modalSettings.js